function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProProgressGroup = void 0;
Object.defineProperty(exports, "ProProgressGroupType", {
  enumerable: true,
  get: function get() {
    return _ProProgressGroupController.ProProgressGroupType;
  }
});
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _useLang = require("./useLang");
var _styles = require("./styles");
var _ProProgressGroupController = require("./ProProgressGroupController");
var _utils = require("../../utils");
var _styles2 = require("../../styles");
var _locales = require("../../locales");
var _components = require("../../components");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var TOGGLE_STATES = {
  TRYING: false,
  DONE: true
};
var ProProgressGroup = exports.ProProgressGroup = (0, _react.memo)(function (_ref) {
  var _Object$keys, _data$metaCommitments, _data$metaCommitments2, _data$metaCommitments3, _data$metaCommitments4, _data$metaCommitments5, _data$metaCommitments6, _data$metaCommitments7, _data$metaCommitments8, _data$metaCommitments9, _data$metaReductions, _data$metaReductions$, _data$metaReductions2, _data$metaReductions3, _data$metaReductions4, _data$metaReductions5, _data$metaReductions6, _data$metaReductions7, _data$metaReductions8, _data$metaReductions9;
  var _ref$controller = _ref.controller,
    controller = _ref$controller === void 0 ? new _ProProgressGroupController.ProProgressGroupController() : _ref$controller,
    id = _ref.id,
    navItems = _ref.navItems,
    type = _ref.type;
  (0, _useLang.useLang)();
  (0, _locales.useFootprintLang)();
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var _useStyles = (0, _styles.useStyles)(),
    styles = _useStyles.styles;
  var _STYLES$useStyles = _styles2.STYLES.useStyles(),
    spacing = _STYLES$useStyles.spacing;
  var _controller$useContro = controller.useController({
      id: id,
      type: type
    }),
    data = _controller$useContro.data,
    isLoading = _controller$useContro.isLoading;
  var _useContext = (0, _react.useContext)(_utils.LinkContext),
    stepsPageLinkUrl = _useContext.stepsPageLinkUrl;
  var _useState = (0, _react.useState)(TOGGLE_STATES.TRYING),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    stepsProgressToggle = _useState2[0],
    setStepsProgressToggle = _useState2[1];
  var _useState3 = (0, _react.useState)(TOGGLE_STATES.TRYING),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    achievementsProgressToggle = _useState4[0],
    setAchievementsProgressToggle = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    breakdownIsOpen = _useState6[0],
    toggleBreakdown = _useState6[1];
  var breakdownItems = (_Object$keys = Object.keys((data == null ? void 0 : data.metaCo2eReductionSections) || {})) == null ? void 0 : _Object$keys.map(function (key) {
    return {
      label: t("footprint:category.".concat(key)),
      value: (data == null ? void 0 : data.metaCo2eReductionSections[key]) || 0,
      unit: 'kg',
      id: key === 'trees' ? 'tree' : undefined
    };
  });
  var _hasNavItems = !!navItems && navItems.length > 0;
  var AlarmImage = (0, _react.memo)(function (props) {
    return (0, _jsxRuntime.jsx)(_components.SvgImage, Object.assign({
      image: require("../../images/AlarmClock.svg")
    }, props));
  });
  var BottleImage = (0, _react.memo)(function (props) {
    return (0, _jsxRuntime.jsx)(_components.SvgImage, Object.assign({
      image: require("../../images/Bottle.svg")
    }, props));
  });
  var CalendarImage = (0, _react.memo)(function (props) {
    return (0, _jsxRuntime.jsx)(_components.SvgImage, Object.assign({
      image: require("../../images/Calendar.svg")
    }, props));
  });
  var FootprintGlobe = (0, _react.memo)(function (props) {
    return (0, _jsxRuntime.jsx)(_components.SvgImage, Object.assign({
      image: require("../../images/FootprintGlobe.svg")
    }, props));
  });
  var Mountain = (0, _react.memo)(function (props) {
    return (0, _jsxRuntime.jsx)(_components.SvgImage, Object.assign({
      image: require("../../images/Mountain.svg")
    }, props));
  });
  var Tap = (0, _react.memo)(function (props) {
    return (0, _jsxRuntime.jsx)(_components.SvgImage, Object.assign({
      image: require("../../images/Tap.svg")
    }, props));
  });
  var Co2Cloud = (0, _react.memo)(function (props) {
    return (0, _jsxRuntime.jsx)(_components.SvgImage, Object.assign({
      image: require("../../images/Co2Cloud.svg")
    }, props));
  });
  if (isLoading) {
    return (0, _jsxRuntime.jsx)(_components.ActivityIndicator, {});
  }
  if (!data) return null;
  return (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [(0, _jsxRuntime.jsx)(_components.ProHeader, {
      backgroundImage: {
        uri: data == null ? void 0 : data.banner
      },
      logoImage: {
        uri: data == null ? void 0 : data.logo
      },
      name: data == null ? void 0 : data.name,
      testID: "ProProgressGroup"
    }), (0, _jsxRuntime.jsxs)(_components.View, {
      style: styles.orgProgressContainer,
      children: [_hasNavItems && (0, _jsxRuntime.jsx)(_components.RoundedNavigation, {
        items: navItems,
        style: styles.navContainer
      }), (0, _jsxRuntime.jsxs)(_components.View, {
        style: styles.stepsContainer,
        children: [(0, _jsxRuntime.jsx)(_components.Heading, {
          level: 2,
          style: styles.stepHeading,
          children: t('proProgressGroup:steps')
        }), (0, _jsxRuntime.jsx)(_components.Text, {
          textStyle: styles.stepCount,
          containerStyle: styles.stepCountContainer,
          children: stepsProgressToggle === TOGGLE_STATES.TRYING ? data == null ? void 0 : (_data$metaCommitments = data.metaCommitments) == null ? void 0 : (_data$metaCommitments2 = _data$metaCommitments.pending.total) == null ? void 0 : _data$metaCommitments2.toLocaleString() : data == null ? void 0 : (_data$metaCommitments3 = data.metaCommitments) == null ? void 0 : (_data$metaCommitments4 = _data$metaCommitments3.successful) == null ? void 0 : (_data$metaCommitments5 = _data$metaCommitments4.total) == null ? void 0 : _data$metaCommitments5.toLocaleString()
        }), (0, _jsxRuntime.jsx)(_components.Text, {
          textStyle: styles.totalStepsText,
          containerStyle: styles.totalStepsTextContainer,
          children: stepsProgressToggle === TOGGLE_STATES.TRYING ? t('proProgressGroup:totalStepsCommitted') : t('proProgressGroup:totalStepsDone')
        })]
      }), (0, _jsxRuntime.jsxs)(_components.View, {
        style: styles.valueBoxContainer,
        spacer: spacing.l,
        children: [(0, _jsxRuntime.jsx)(_components.ValueBox, {
          value: stepsProgressToggle === TOGGLE_STATES.TRYING ? data == null ? void 0 : (_data$metaCommitments6 = data.metaCommitments) == null ? void 0 : _data$metaCommitments6.pending['7_days_total'] : data == null ? void 0 : (_data$metaCommitments7 = data.metaCommitments) == null ? void 0 : _data$metaCommitments7.successful['7_days_total'],
          label: stepsProgressToggle === TOGGLE_STATES.TRYING ? t('proProgressGroup:stepsCommittedThisWeek') : t('proProgressGroup:stepsDoneThisWeek'),
          Image: AlarmImage,
          style: styles.valueBox,
          imageSize: 60
        }), (0, _jsxRuntime.jsx)(_components.ValueBox, {
          value: stepsProgressToggle === TOGGLE_STATES.TRYING ? data == null ? void 0 : (_data$metaCommitments8 = data.metaCommitments) == null ? void 0 : _data$metaCommitments8.pending['30_days_total'] : data == null ? void 0 : (_data$metaCommitments9 = data.metaCommitments) == null ? void 0 : _data$metaCommitments9.successful['30_days_total'],
          label: stepsProgressToggle === TOGGLE_STATES.TRYING ? t('proProgressGroup:stepsCommittedThisMonth') : t('proProgressGroup:stepsDoneThisMonth'),
          Image: CalendarImage,
          style: styles.valueBox,
          imageSize: 60
        })]
      }), (0, _jsxRuntime.jsx)(_components.Toggle, {
        accessibilityLabel: t('proProgressGroup:toggleSteps'),
        testID: "toggle-steps",
        falseLabel: t('proProgressGroup:trying'),
        trueLabel: t('proProgressGroup:done'),
        value: stepsProgressToggle,
        onChange: function onChange() {
          return setStepsProgressToggle(!stepsProgressToggle);
        },
        style: styles.progressToggle
      }), stepsPageLinkUrl && (0, _jsxRuntime.jsx)(_components.Button, {
        label: t('proProgressGroup:viewAllSteps'),
        type: _components.ButtonType.brand,
        href: stepsPageLinkUrl,
        containerStyle: styles.stepsButtonContainer
      }), (0, _jsxRuntime.jsxs)(_components.View, {
        style: styles.achievementsGroup,
        children: [(0, _jsxRuntime.jsx)(_components.Heading, {
          level: 2,
          style: styles.achievementHeader,
          children: t('proProgressGroup:achievements')
        }), (0, _jsxRuntime.jsxs)(_components.View, {
          style: styles.achievements,
          children: [(0, _jsxRuntime.jsx)(_components.AchievementItem, {
            imageSize: 100,
            Image: Co2Cloud,
            achievementValueUnit: "kg",
            achievementValue: achievementsProgressToggle === TOGGLE_STATES.TRYING ? data == null ? void 0 : (_data$metaReductions = data.metaReductions) == null ? void 0 : (_data$metaReductions$ = _data$metaReductions.pending) == null ? void 0 : _data$metaReductions$.co2e : data == null ? void 0 : (_data$metaReductions2 = data.metaReductions) == null ? void 0 : (_data$metaReductions3 = _data$metaReductions2.successful) == null ? void 0 : _data$metaReductions3.co2e,
            achievementLabel: achievementsProgressToggle === TOGGLE_STATES.TRYING ? t('proProgressGroup:committedCo2') : t('proProgressGroup:successfulCo2')
          }), (0, _jsxRuntime.jsx)(_components.AchievementItem, {
            imageSize: 100,
            Image: Tap,
            achievementValueUnit: "litres",
            achievementValue: achievementsProgressToggle === TOGGLE_STATES.TRYING ? data == null ? void 0 : (_data$metaReductions4 = data.metaReductions) == null ? void 0 : _data$metaReductions4.pending.water : data == null ? void 0 : (_data$metaReductions5 = data.metaReductions) == null ? void 0 : _data$metaReductions5.successful.water,
            achievementLabel: achievementsProgressToggle === TOGGLE_STATES.TRYING ? t('proProgressGroup:committedWater') : t('proProgressGroup:successfulWater')
          }), (0, _jsxRuntime.jsx)(_components.AchievementItem, {
            imageSize: 100,
            Image: Mountain,
            achievementValueUnit: "m2",
            achievementValue: achievementsProgressToggle === TOGGLE_STATES.TRYING ? data == null ? void 0 : (_data$metaReductions6 = data.metaReductions) == null ? void 0 : _data$metaReductions6.pending.land : data == null ? void 0 : (_data$metaReductions7 = data.metaReductions) == null ? void 0 : _data$metaReductions7.successful.land,
            achievementLabel: achievementsProgressToggle === TOGGLE_STATES.TRYING ? t('proProgressGroup:committedLand') : t('proProgressGroup:successfulLand')
          }), (0, _jsxRuntime.jsx)(_components.AchievementItem, {
            imageSize: 100,
            Image: BottleImage,
            achievementValueUnit: "items",
            achievementValue: achievementsProgressToggle === TOGGLE_STATES.TRYING ? data == null ? void 0 : (_data$metaReductions8 = data.metaReductions) == null ? void 0 : _data$metaReductions8.pending.plastic : data == null ? void 0 : (_data$metaReductions9 = data.metaReductions) == null ? void 0 : _data$metaReductions9.successful.plastic,
            achievementLabel: achievementsProgressToggle === TOGGLE_STATES.TRYING ? t('proProgressGroup:committedPlastic') : t('proProgressGroup:successfulPlastic')
          })]
        }, "achivements-".concat(achievementsProgressToggle))]
      }), (0, _jsxRuntime.jsx)(_components.Toggle, {
        accessibilityLabel: "toggle-achievements",
        falseLabel: t('proProgressGroup:trying'),
        trueLabel: t('proProgressGroup:done'),
        value: achievementsProgressToggle,
        onChange: function onChange() {
          return setAchievementsProgressToggle(function (prevState) {
            return !prevState;
          });
        },
        style: styles.progressToggle,
        testID: "toggle-achievements"
      }), (0, _jsxRuntime.jsx)(_components.View, {
        style: styles.footprintSection,
        children: (0, _jsxRuntime.jsxs)(_components.View, {
          style: styles.mediaObjectContainer,
          children: [(0, _jsxRuntime.jsx)(_components.Heading, {
            level: 2,
            style: styles.alignCenter,
            children: t('proProgressGroup:footprint')
          }), (0, _jsxRuntime.jsx)(_components.MediaObject, {
            Image: FootprintGlobe,
            value: data == null ? void 0 : data.kgCo2eEmissions,
            valueUnit: "kg",
            label: t('proProgressGroup:averageCarbonFootprint')
          }), (0, _jsxRuntime.jsx)(_components.Button, {
            onPress: function onPress() {
              return toggleBreakdown(!breakdownIsOpen);
            },
            fullWidth: true,
            containerStyle: styles.footPrintButton,
            type: _components.ButtonType.brand,
            testID: "toggle-breakdown",
            accessibilityLabel: "toggle-breakdown",
            children: !breakdownIsOpen ? t('proProgressGroup:viewBreakdown') : t('proProgressGroup:hideBreakdown')
          }), breakdownIsOpen && (0, _jsxRuntime.jsx)(_components.HorizontalBarChart, {
            items: breakdownItems,
            style: styles.barChartContainer,
            testID: "breakdown-chart"
          })]
        })
      })]
    })]
  });
});